import {Property} from "csstype";

export const display = (value: Property.Display) => `
    display: ${value};
`;
import {Property} from "csstype";

export const display = (value: Property.Display) => `
    display: ${value};
`;
